const SHARE_PREVIEW_VERSION = "v6";

export function versionedShareUrl(url) {
  const shareUrl = new URL(url);
  shareUrl.searchParams.delete("test");
  shareUrl.searchParams.set("tfcard", SHARE_PREVIEW_VERSION);
  return shareUrl.href;
}

export async function shareVideoLink(url, title, { navigatorRef = navigator, documentRef = document } = {}) {
  if (typeof navigatorRef.share === "function") {
    try {
      await navigatorRef.share({ title, url });
      return "shared";
    } catch (error) {
      if (error?.name === "AbortError") return "cancelled";
    }
  }

  try {
    if (typeof navigatorRef.clipboard?.writeText === "function") {
      await navigatorRef.clipboard.writeText(url);
      return "copied";
    }
  } catch { /* Clipboard access can be denied; try the older browser fallback. */ }

  let input;
  try {
    input = documentRef.createElement("textarea");
    input.value = url;
    input.setAttribute("readonly", "");
    input.style.position = "fixed";
    input.style.opacity = "0";
    documentRef.body.appendChild(input);
    input.select();
    input.setSelectionRange(0, input.value.length);
    return documentRef.execCommand?.("copy") ? "copied" : "failed";
  } catch {
    return "failed";
  } finally {
    input?.remove();
  }
}
